import React from "react";
import { Accordion, Card } from "react-bootstrap";
import { AccordionToggleCustom } from "../Utility/AccordionToggleCustom";
import { BsChevronDown, BsChevronUp } from "react-icons/bs";

export const CDKGuideAccordionCard = ({
  title,
  eventKey,
  children,
  openByDefault = true,
  containerStyle,
  containerClass,
}) => {
  return (
    <Accordion
      defaultActiveKey={openByDefault ? eventKey : ""}
      style={containerStyle}
      className={containerClass}
    >
      <Card>
        <AccordionToggleCustom
          styleContainer={{
            backgroundColor: "transparent",
            border: 0,
            outline: 0,
          }}
          eventKey={eventKey}
          expandedStateChildren={
            <div className="d-flex justify-content-between p-2">
              <div>{title}</div>
              <div>
                <BsChevronUp />
              </div>
            </div>
          }
          collapsedStateChildren={
            <div className="d-flex justify-content-between p-2">
              <div>{title}</div>
              <div>
                <BsChevronDown />
              </div>
            </div>
          }
        />
        <Accordion.Collapse eventKey={eventKey}>{children}</Accordion.Collapse>
      </Card>
    </Accordion>
  );
};
